import { PostInsights } from '@frontend/gql/social/graphql';
import { UseGenericTableConfig, useGenericTable } from './useGenericTable';

export const usePostTable = (config: UseGenericTableConfig<PostInsights>) => {
  const { tableProps } = useGenericTable<PostInsights>(config);
  return {
    postTableProps: tableProps,
  };
};
